import React, { useEffect } from "react";
import { useImageStoreFN, useIsMobile, useLanguage } from "src/hooks";

import FTButton from "../FTButton";
import { FTImageStore } from "src/store";
import { IconPostToCommunity } from "src/assets";
import { autorun } from "mobx";
import loadable from "@loadable/component";
import styles from "./PostCommunity.module.scss";
import { urls } from "src/constant";

// import { utils } from "face-api.js";

const FTPoseCommunity = loadable(() => import("@ft/post-community"));
function loadSignScript() {
  return new Promise<void>(async (resolve, reject) => {
    if (window["login"] && window["login"].showLogin) {
      resolve();
    } else {
      const bodyScript = document.createElement("script");
      bodyScript.setAttribute("src", urls.loginSdk || "");
      bodyScript.defer = true;
      bodyScript.onload = function onLoad() {
        resolve();
      };
      bodyScript.onerror = function onLoad() {
        resolve();
      };
      document.body.appendChild(bodyScript);
    }
  });
}

export interface IPostCommunityProps {}

export default function PostCommunity() {
  const { language, t } = useLanguage();
  const isMobile = useIsMobile();
  const showPost = useImageStoreFN((state) => state.showPost);
  const [visible, setVisible] = React.useState(false);
  const currentEffect = useImageStoreFN((state) => state.currentEffect);
  const getCurrentPostTask = useImageStoreFN(
    (state) => state.getCurrentPostTask
  );
  const [effectDownloadImageUrl, setEffectDownloadImageUrl] =
    React.useState("");
  const [originUrl, setOriginUrl] = React.useState("");
  useEffect(() => {
    const dispose = autorun(() => {
      setEffectDownloadImageUrl(
        (FTImageStore.effectElement as HTMLImageElement)?.src ?? ""
      );
      setOriginUrl(FTImageStore.uploadImageUrl || "");
    });
    FTPoseCommunity.preload();
    return () => {
      dispose();
    };
  }, []);
  const taskId = getCurrentPostTask?.taskId ?? "";
  return (
    <div hidden={!showPost}> 
      <FTButton
        className={styles.btn}
        onClick={() => {
          setVisible(true);
        }}>
        <IconPostToCommunity />
        <span>{t("post_to_community")}</span>
      </FTButton>
      <FTPoseCommunity
        showPostedGuide={true}
        lang={language}
        zIndex={10007}
        key='post-community'
        postSource={{
          // workId: openPostOpts.id!,
          imageUrl: effectDownloadImageUrl,
          originImgUrl: originUrl,
          isPrompts: false,
          workId: taskId,
          type: "goart"
        }}
        singlePost={true}
        // open

        open={visible}
        onPost={(exe: Promise<any>, options: any, isEdit: boolean) => {
          return exe
            ?.then((res) => {
              setTimeout(() => {
                FTImageStore.postSuccess(taskId);
              });
            })
            ?.catch((error) => {
              console.error(error, isEdit);
            });
        }}
        loadSignScript={loadSignScript}
        isMobile={isMobile}
        onClose={() => {
          setTimeout(() => {
            setVisible(false);
          }, 500);
        }}
        onSelect={(workId?: string, params?: any) => {
          // 埋点
          // Analytic.chooseCreationAnalytic({ ...params });
        }}
        domain={process.env.REACT_APP_BASE_URL}
        environment={
          process.env.REACT_APP_ENVIRONMENT === "production"
            ? "production"
            : "development"
        }
      />
    </div>
  );
}
